import { useCallback } from 'react';
import { ApiCall } from '../helper/axios';
import { useSelector } from 'react-redux';
export function useOptedOutCheck() {
    const token = useSelector((state) => state.auth.token);
    const checkEmail = useCallback(async (email) => {
        const trimmed = email.trim().toLowerCase();
        if (!trimmed)
            return false;
        try {
            const res = await ApiCall('GET', `/api/opted-out-contacts/check`, { email: trimmed }, { Authorization: token });
            const data = res?.data;
            return data?.success && data?.data?.is_opted_out === true;
        }
        catch {
            return false;
        }
    }, [token]);
    return checkEmail;
}
